var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cats-CategoryBoard"},[_c('p',{staticClass:"cats-CategoryBoard_HeaderTitle"},[_vm._v("\n    すべてのカテゴリー\n  ")]),_vm._v(" "),_c('CategoryMenu',{attrs:{"product-categories":_vm.productCategories,"is-footer":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }